import { createGenericColumns, createRowsData } from "../../utils/tableUtils";

export const createFieldTypeRowsData = createRowsData("fieldTypeName");

export const createFieldTypeColumns = (actions) =>
  createGenericColumns({
    nameField: "fieldTypeName",
    nameHeader: "Nome Tipologia",
    actions,
    nameMinWidth: 200,
  });
